// extracted by mini-css-extract-plugin
export var questionBox = "_6t-0";